import Hero from "../../../../src/components/project/hero";
import GetStarted from "../../../../src/components/project/get-started";
import ChronosImage from "../../../../src/components/project/chronos-image";
import * as React from 'react';
export default {
  Hero,
  GetStarted,
  ChronosImage,
  React
};